import usOptions from './us';
import caOptions from './ca';

export default {
  us: usOptions,
  ca: caOptions,
};



// WEBPACK FOOTER //
// ./src/configs/sites/index.js